import trTR from 'element-ui/lib/locale/lang/tr-TR';

// 土耳其语(土耳其)
export default {
  ...trTR,
  layout: {
    title: 'Uniportal Kimliği ile Giriş Yap',
    tip: 'Kayıtsız cep telefonu numaraları başarılı bir şekilde giriş yaptıktan sonra otomatik olarak kaydedilecektir',
    line: 'Diğer Giriş Seçenekleri',
  },
  button: {
    submit: 'Giriş/Kayıt',
    getCode: 'Kod al',
    emailRegister: 'E-posta ile Kaydolma',
    w3Login: 'W3 Hesabı Girişi',
    employeeLogin: 'Çalışan Girişi',
    passwordLogin: 'Şifre Girişi',
    reSend: 'Yeniden gönder',
    problem: 'Çevrimiçi Yardım',
    privacyPolicy: 'Gizlilik Bildirimi',
  },
  placeholder: {
    phoneNumber: 'Cep telefonu numarası',
    verificationCode: 'SMS doğrulama kodu',
  },
  dialog: {
    imgCode: 'Görseldeki karakterleri girin.',
    userAgreements: {
      header: 'Kullanıcı Sözleşmesi ve Gizlilik Beyanı',
      text1: 'Lütfen {privacy} ile {agreement} içeriklerini okuyun ve kabul edin.',
      text2:
        "Kişisel bilgiler Huawei'nin denizaşırı uygulamalarına eriştiğinde, Huawei'nin denizaşırı iştiraklerine aktarılacaktır. Ayrıntılar için {privacy} bölümüne bakın",
    },
    crossBorder: {
      header: 'Yetkilendirme istemi',
      text: 'Kullandığınız yerel hizmet ile hesabınızın kayıtlı olduğu yer aynı bölgede değil. Hesap bilgilerine sınır ötesi erişim için yetkiniz gereklidir.',
    },
    multiAccounts: 'Bir hesap seçin.',
    agreeButton: 'Kabul ve Devam Et',
    disagreeButton: 'Kabul etmiyorum',
    confirmButton: 'Onaylandı',
    cancelButton: 'iptal etmek',
    knowMe: 'Tamam',
  },
  toast: {
    hasSend: 'Doğrulama kodu gönderildi.',
    wait: 'Bir dakika, lütfen',
  },
  tooltip: {
    Huawei: 'Huawei Kimliği',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'CAPTCHA kodu boş bırakılamaz.',
    'IDC-03-0002': 'CAPTCHA kodunun süresi sona erdi.',
    'IDC-00-0004': 'Hatalı CAPTCHA kodu.',

    // 表单输入为空
    'IDC-01-00024': 'Cep telefonu numaranızı doğrulamak için ülke kodu gereklidir.',
    phoneNumberEmpty: 'Cep telefonu numarasını girin.',
    'IDC-03-00033': 'SMS doğrulama kodunu girin.',

    // 表单数据错误
    'IDC-02-00227': 'Girilen cep telefonu numarası seçilen ülke/bölge ile eşleşmiyor',
    'IDC-02-00226': 'Ülke kodu yasaktır',
    'IDC-02-00029': 'Doğrulama kodu yanlış veya süresi dolmuş',
    'IDC-02-0013': 'Doğrulama kodu yanlış olduğu için SMS girişi başarısız oldu',
    'IDC-02-0020': 'Doğrulama başarısız. Hatalı doğrulama kodu.',
    'IDC-02-00028': 'Cep telefonu numarası 6 ila 30 basamaktan oluşan bir dize olmalıdır',
    'IDC-02-00012': 'Yanlış cep telefonu numarası',

    // 错误操作锁定
    accountLock:
      'Hatalı cep telefonu numarası veya doğrulama kodu. {number} deneme kaldı. | Hatalı cep telefonu numarası veya doğrulama kodu. {number} deneme kaldı.',
    accountLocked:
      'Çok fazla başarısız deneme yapıldı. Lütfen {number} saniye sonra tekrar deneyin. | Çok fazla başarısız deneme yapıldı. Lütfen {number} saniye sonra tekrar deneyin.',
    operationRisk: 'Bu işlemin güvenlik riskleri var . Lütfen {number} saniye sonra tekrar deneyin .',

    // 频繁操作
    'IDC-02-00038': 'Lütfen 60 saniye sonra tekrar deneyin.',
    'IDC-02-00064':
      'SMS doğrulama kodunu sık sık gönderiyorsunuz . Lütfen 24 saat sonra tekrar deneyin .',
    'IDC-02-00211': 'Bu işlemin güvenlik riskleri var . Lütfen daha sonra tekrar deneyin .',
    'IDC-02-00212':
      'Cep telefonu numaranız sık sık SMS doğrulama kodları gönderir . Lütfen cep telefonu numaranızı değiştirin veya 24 saat sonra tekrar deneyin .',
    'IDC-02-00213':
      'SMS doğrulama kodunu sık sık gönderiyorsunuz . Lütfen 24 saat sonra tekrar deneyin .',
    'IDC-02-00215':
      'Cep telefonu numaranız sık sık SMS doğrulama kodları gönderir . Lütfen cep telefonu numaranızı değiştirin , başka bir doğrulama yöntemi seçin veya 24 saat sonra tekrar deneyin .',
    'IDC-02-00228':
      'SMS doğrulama kodunu sık sık gönderiyorsunuz . Lütfen bir saat sonra tekrar deneyin .',
    'IDC-02-00092': 'Mevcut işlem çok sık. Lütfen 24 saat sonra tekrar deneyin.',

    // 请求异常
    'IDC-10-00400': 'Müşteri isteği anormal',
    'IDC-10-00500': 'İç sistem hatası ',
    'IDC-02-00264': 'Yetkisiz erişim talepleri yasaktır',
    'IDC-02-00063': 'Geçersiz parametre',
    'IDC-03-0007': 'Mevcut işlem güvenlik riskleri içerir ve kayıt geçici olarak başarısız olur.', // 机翻
    'IDC-03-00057': 'Mevcut operasyonun güvenlik riskleri vardır.',

    // 页面过期
    'IDC-00-00017': 'Sayfanın süresi sona erdi.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Geri',
  closeButton: 'Kapat',

  // 滑块验证相关：
  resourceReqFailed: 'Kaynak isteği başarısız oldu. Sayfayı yenileyin ve tekrar deneyin.',
  verifyFailedAndPlsRetry: 'Doğrulama başarısız oldu, lütfen tekrar deneyin',
  serviceErrAndPlsRetry: 'Servis istisnası. Lütfen tekrar deneyin.',
  learnMore: 'Daha fazla bilgi edinin',
  cookieBannerText: 'Bu web sitesi size en iyi kullanıcı deneyimini sunmak için çerez işlevini kullanır.',
};
